import(/* webpackMode: "eager" */ "/vercel/path0/packages/wello/src/app/(allowed)/(home)/layout.tsx");
